export enum MailProvider {
    sendgrid = 'sendgrid',
    nodemailer = 'nodemailer',
}
